// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__26EvB","header":"MessagesList_header__gfBZl","chat":"MessagesList_chat__1H4sP"};